import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safe-secure',
  templateUrl: './safe-secure.component.html',
  styleUrls: ['./safe-secure.component.scss']
})
export class SafeSecureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
